import React from 'react'

// Date + time label for the left gutter of a .timeline.timed item
const FeedTime = ({ value }) => {
  if (!value) return <span className="time">--</span>

  const d = new Date(value)
  const date = d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
  const time = d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })

  return (
    <span className="time">
      <time dateTime={d.toISOString()}>
        {date}{' '}
        <br />
        {time}
      </time>
    </span>
  )
}

export default FeedTime
